import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://quxasqjlhohghnuurvvl.supabase.co';
const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF1eGFzcWpsaG9oZ2hudXVydnZsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM0MjIzODMsImV4cCI6MjA4ODk5ODM4M30.icqPRA4-TOTaIfHyKFVess2AmY5N_4tlm96XRVqI84E';

export const sb = createClient(SUPABASE_URL, SUPABASE_KEY);

export type Company = {
  id: string; name: string; slug: string;
  plan: 'trial' | 'starter' | 'growth' | 'enterprise';
  is_active: boolean; billing_email?: string; industry?: string;
  city?: string; plan_employee_limit?: number; trial_ends_at?: string;
  created_at: string;
  feature_attendance?: boolean; feature_leave?: boolean; feature_payroll?: boolean;
};

export type User = {
  id: string; full_name: string; email: string; role: string;
  company_id?: string; employee_code?: string; phone?: string;
  face_enrolled: boolean; is_geofenced: boolean; is_active: boolean;
  kiosk_only?: boolean; location_id?: string; shift_id?: string;
  created_at: string; company?: { name: string };
};

export type LeaveType = {
  id: string; company_id: string; name: string; days_allowed: number;
  carry_forward: boolean; paid: boolean; requires_approval: boolean;
  applicable_after_days: number;
};

export type Leave = {
  id: string; user_id: string; company_id: string;
  leave_type_id?: string; start_date: string; end_date: string;
  total_days?: number; reason?: string; status: string;
  half_day?: boolean; rejection_reason?: string;
  created_at: string;
  user?: { full_name: string; employee_code?: string };
  leave_type?: { name: string };
};
